(function () {
  if (window.__atomeOurProductsHub) return;
  window.__atomeOurProductsHub = true;

  var BUILDER_URL = '/products/build-your-box-1';
  var SEED_KEY = 'bmb_seed';
  var drawer = null;
  var bodyEl = null;
  var products = {};
  var fromPrice = '14.60';
  var fallbackTitles = [];

  function moneyFrom(value) {
    var n = parseFloat(value);
    if (!isFinite(n)) n = parseFloat(fromPrice) || 14.6;
    return n.toFixed(2);
  }

  function extraMoney(cents) {
    var n = (parseFloat(cents) || 0) / 100;
    return '$' + n.toFixed(2).replace(/\.00$/, '');
  }

  function formatUnitLabel(label) {
    var raw = String(label == null ? '' : label).trim();
    if (!raw) return 'item';
    var rest = raw.slice(1);
    if (rest && rest !== rest.toLowerCase()) return raw;
    return raw.toLowerCase();
  }

  function fromLine(p) {
    var units = p ? parseFloat(p.unitsPerProduct) : 0;
    if (!isFinite(units) || units <= 0) {
      return 'From $' + moneyFrom(fromPrice) + ' in a box';
    }
    var per = parseFloat(fromPrice) / units;
    return 'From $' + moneyFrom(per) + ' per ' + formatUnitLabel(p.unitLabel);
  }

  function extraLine(p) {
    if (!p) return '';
    if (p.priceVaries) return 'From $' + moneyFrom((p.priceMin || p.price) / 100);
    return extraMoney(p.price);
  }

  function priceLine(p, asExtra) {
    return asExtra ? extraLine(p) : fromLine(p);
  }

  function tidyHtml(html) {
    if (!html) return '';
    var d = document.createElement('div');
    d.innerHTML = html;
    Array.prototype.slice.call(d.querySelectorAll('p, div')).forEach(function (el) {
      var text = (el.textContent || '').replace(/\u00a0/g, ' ').trim();
      if (!text && !el.querySelector('img, iframe, video, picture')) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    });
    return d.innerHTML;
  }

  function loadProducts() {
    var choice = document.querySelector('.oph-choice[data-from-price]');
    if (choice && choice.getAttribute('data-from-price')) {
      fromPrice = String(choice.getAttribute('data-from-price'));
    }
    var node = document.getElementById('our-products-data');
    if (!node) return;
    try {
      var parsed = JSON.parse(node.textContent || '{}');
      products = parsed.products || {};
      if (parsed.fromPrice) fromPrice = String(parsed.fromPrice);
      if (choice && choice.getAttribute('data-from-price')) fromPrice = String(choice.getAttribute('data-from-price'));
      fallbackTitles = parsed.fallbacks || [];
    } catch (err) {
      products = {};
    }
    document.querySelectorAll('.oph-card').forEach(function (card) {
      var hit = card.querySelector('[data-oph-open]');
      var fromEl = card.querySelector('.oph-card__from');
      if (!hit || !fromEl) return;
      var handle = hit.getAttribute('data-oph-open');
      var p = products[handle];
      if (!p) return;
      var asExtra = fromEl.getAttribute('data-oph-extra') === 'true';
      fromEl.textContent = priceLine(p, asExtra);
      if (asExtra) fromEl.removeAttribute('data-oph-fallback');
      else if (!(parseFloat(p.unitsPerProduct) > 0)) fromEl.setAttribute('data-oph-fallback', 'true');
      else fromEl.removeAttribute('data-oph-fallback');
    });
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function accordion(title, html, image) {
    if (!html && !image) return '';
    var inner = html ? '<div class="oph-acc__rich">' + html + '</div>' : '';
    if (image) inner += '<img src="' + esc(image) + '" alt="">';
    return (
      '<details class="oph-acc">' +
        '<summary>' + esc(title) + '</summary>' +
        '<div class="oph-acc__body">' + inner + '</div>' +
      '</details>'
    );
  }

  function drawerScroller() {
    if (!drawer) return null;
    try {
      if (drawer.shadowRoot) {
        var part = drawer.shadowRoot.querySelector('[part="body"], [part~="body"]');
        if (part) return part;
      }
    } catch (e) {}
    return drawer;
  }

  function resetDrawerScroll() {
    var scroller = drawerScroller();
    if (scroller) scroller.scrollTop = 0;
    if (bodyEl) bodyEl.scrollTop = 0;
    if (drawer) drawer.scrollTop = 0;
  }

  function seedAndGo(p) {
    var payload = {
      variantId: p.variantId || null,
      productId: p.productId || p.id || null,
      qty: 1
    };
    try { sessionStorage.setItem(SEED_KEY, JSON.stringify(payload)); } catch (err) {}
    window.location.href = BUILDER_URL;
  }

  function fill(handle, asExtra) {
    var p = products[handle];
    if (!p || !bodyEl) return false;
    var titleEl = document.getElementById('oph-drawer-title');
    if (titleEl) titleEl.textContent = p.title || 'Product';

    var images = (p.images && p.images.length) ? p.images : (p.image ? [p.image] : []);
    var imgHtml = images.map(function (src) {
      return '<img src="' + esc(src) + '" alt="' + esc(p.title) + '" width="320" height="240" loading="lazy">';
    }).join('');

    var desc = tidyHtml(p.description || '');

    bodyEl.innerHTML =
      (imgHtml ? '<div class="oph-drawer__images">' + imgHtml + '</div>' : '') +
      '<h2 class="oph-drawer__title">' + esc(p.title) + '</h2>' +
      '<p class="oph-drawer__from">' + esc(priceLine(p, asExtra)) + '</p>' +
      (desc ? '<div class="oph-drawer__desc">' + desc + '</div>' : '') +
      '<div class="oph-drawer__pills">' +
        '<button class="oph-pill" type="button" data-oph-seed data-variant-id="' + esc(String(p.variantId || '')) + '" data-product-id="' + esc(String(p.productId || p.id || '')) + '">Add to box</button>' +
      '</div>' +
      accordion('Instructions Baking', p.instructions, null) +
      accordion('Nutritional Facts', p.nutrition, p.nutritionImage) +
      accordion('Ingredients', p.ingredients, null) +
      accordion('Allergens', p.allergens, null) +
      (p.url ? '<p class="oph-drawer__fullpage"><a href="' + esc(p.url) + '">View full page</a></p>' : '');

    resetDrawerScroll();
    return true;
  }

  function open(handle, asExtra) {
    if (!fill(handle, asExtra)) {
      window.location.href = '/products/' + encodeURIComponent(handle);
      return;
    }
    resetDrawerScroll();
    if (drawer && typeof drawer.show === 'function') drawer.show();
    resetDrawerScroll();
    window.requestAnimationFrame(function () {
      resetDrawerScroll();
      window.setTimeout(resetDrawerScroll, 80);
      window.setTimeout(resetDrawerScroll, 250);
    });
  }

  function onClick(e) {
    var seedBtn = e.target.closest && e.target.closest('[data-oph-seed]');
    if (seedBtn) {
      var vid = parseInt(seedBtn.getAttribute('data-variant-id'), 10);
      var pid = parseInt(seedBtn.getAttribute('data-product-id'), 10);
      if (vid || pid) {
        e.preventDefault();
        e.stopPropagation();
        seedAndGo({
          variantId: vid || null,
          productId: pid || null,
          id: pid || null
        });
        return;
      }
    }
    var hit = e.target.closest && e.target.closest('[data-oph-open]');
    if (!hit) return;
    var handle = hit.getAttribute('data-oph-open');
    if (!handle) return;
    e.preventDefault();
    e.stopPropagation();
    open(handle, hit.getAttribute('data-oph-extra') === 'true');
  }

  function init() {
    loadProducts();
    drawer = document.getElementById('our-products-drawer');
    bodyEl = document.getElementById('oph-drawer-body');
    document.addEventListener('click', onClick);
    if (fallbackTitles && fallbackTitles.length && window.console) {
      console.info('[oph] from-price fallbacks', fallbackTitles.length, fallbackTitles);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
